var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts"},[_c('IEcharts',{attrs:{"option":_vm.bar,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }